import { render, staticRenderFns } from "./ShopOpenPage.vue?vue&type=template&id=da20d966&scoped=true&"
import script from "./ShopOpenPage.vue?vue&type=script&lang=js&"
export * from "./ShopOpenPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopOpenPage.vue?vue&type=style&index=0&id=da20d966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da20d966",
  null
  
)

export default component.exports